import { useMemo, useRef } from 'react'
import type { GeminiLiveService } from '@/services/geminiLiveService'
import type { InterviewRecordingManager } from '@/services/recording'
import type { SessionRefs } from './types'

export function useSessionRefs(): SessionRefs {
  const videoRef = useRef<HTMLVideoElement>(null)
  const pipVideoRef = useRef<HTMLVideoElement>(null)
  const canvasRef = useRef<HTMLCanvasElement>(null)
  const serviceRef = useRef<GeminiLiveService | null>(null)
  const mediaStreamRef = useRef<MediaStream | null>(null)
  const screenStreamRef = useRef<MediaStream | null>(null)
  const isScreenSharingRef = useRef(false)
  const isConnectingRef = useRef(false)
  const recordingManagerRef = useRef<InterviewRecordingManager | null>(null)
  const frameIntervalRef = useRef<number | null>(null)
  const audioMixingContextRef = useRef<AudioContext | null>(null)
  const mixedAudioStreamRef = useRef<MediaStream | null>(null)
  const pipCanvasRef = useRef<HTMLCanvasElement | null>(null)
  const pipCompositeStreamRef = useRef<MediaStream | null>(null)
  const pipAnimationRef = useRef<number | null>(null)
  const lastActivityRef = useRef(Date.now())
  const lastKeepAliveRef = useRef(0)
  const startInterviewRef = useRef<() => void>(() => {
    void 0
  })
  const shouldReconnectRef = useRef(true)
  const reconnectTimeoutRef = useRef<NodeJS.Timeout | null>(null)
  const reconnectBackoffRef = useRef(2000)
  const isIntentionallyDisconnectingRef = useRef(false)
  const reconnectAttemptsRef = useRef(0)
  const notificationTimerRef = useRef<NodeJS.Timeout | null>(null)

  return useMemo(
    () => ({
      videoRef,
      pipVideoRef,
      canvasRef,
      serviceRef,
      mediaStreamRef,
      screenStreamRef,
      isScreenSharingRef,
      isConnectingRef,
      recordingManagerRef,
      frameIntervalRef,
      audioMixingContextRef,
      mixedAudioStreamRef,
      pipCanvasRef,
      pipCompositeStreamRef,
      pipAnimationRef,
      lastActivityRef,
      lastKeepAliveRef,
      startInterviewRef,
      shouldReconnectRef,
      reconnectTimeoutRef,
      reconnectBackoffRef,
      isIntentionallyDisconnectingRef,
      reconnectAttemptsRef,
      notificationTimerRef,
    }),
    []
  )
}
